import { isOrg } from '@web-common/components/util/contact';
import React from 'react';
import AvatarTag from './avatarTag';
import { util } from 'api';
import { TeamAvatar } from '@web-im/common/imUserAvatar';
import CustomerAvatar from '@/images/icons/contact/customer_avatar.svg';
import ClueAvatar from '@/images/icons/contact/clue_avatar.svg';
import { ReactComponent as OrgIcon } from '@/images/icons/contact/org_icon.svg';
export const ContactOrgAvatar = props => {
    const { item: _item, className } = props;
    let Avatar = null;
    if (!isOrg(_item)) {
        const item = _item;
        Avatar = React.createElement(AvatarTag, { className: className, size: 32, propEmail: item.email, contactId: item.id, user: { name: item.name } });
    }
    else {
        const item = _item;
        Avatar = React.createElement(AvatarTag, { className: className, size: 32, user: { name: item.orgName, color: util.getColor(item.id || item.orgName) }, avatarImg: React.createElement(OrgIcon, null) });
        if (item.type === 2000) {
            const { id, avatar } = item;
            const teamId = id.startsWith('team_') ? id.split('team_')[1] : id;
            const teamInfo = { teamId, avatar };
            Avatar = React.createElement(TeamAvatar, { teamId: teamInfo.teamId, teamInfo: teamInfo });
        }
        else if (item.type === 2002) {
            Avatar = (React.createElement(AvatarTag, { className: className, user: {
                    avatar: CustomerAvatar,
                } }));
        }
        else if (item.type === 2003) {
            Avatar = (React.createElement(AvatarTag, { className: className, user: {
                    avatar: ClueAvatar,
                } }));
        }
    }
    return Avatar;
};
